import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['activationCheckbox', 'settingsSection', 'weightPrecision', 'splitWeightCheckbox'];

  declare activationCheckboxTarget: HTMLInputElement;
  declare settingsSectionTarget: HTMLElement;
  declare weightPrecisionTarget: HTMLSelectElement;
  declare hasSplitWeightCheckboxTarget: boolean;
  declare splitWeightCheckboxTarget: HTMLInputElement;

  connect(): void {
    if (this.hasSplitWeightCheckboxTarget && this.splitWeightCheckboxTarget.disabled) {
      this.splitWeightCheckboxTarget.checked = false;
    }
  }

  public toggleSetting(_event: any): void {
    if (this.activationCheckboxTarget.checked) {
      this.settingsSectionTarget.classList.add("active");
    } else {
      this.settingsSectionTarget.classList.remove("active");
    }
  }

  public onWeightDistributionChange(event: any): void {
    this.weightPrecisionTarget.value = "0";
  }
}
